// extracted by mini-css-extract-plugin
export default {"video-js":"Player_video-js__Ej455","vjs-tech":"Player_vjs-tech__EElY7"};